import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormGroup, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { AnnuityLotService } from 'src/app/services/annuity-lot.service';
import { Lot } from 'src/app/models/lot';
import { AnnuityPriceDialogComponent } from '../annuity-price-dialog/annuity-price-dialog.component';
import { AnnuityPriceService } from 'src/app/services/annuity-price.service';
import { ConfirmComponent } from 'src/app/shared/dialogs/confirm/confirm.component';
import { SnackBarIconService } from 'src/app/shared/snack-bar-icon/snack-bar-icon.service';
import { AnnuityCatPriceService } from 'src/app/services/annuity-cat-price.service';
import { AnnuityCatPriceDialogComponent } from '../annuity-cat-price-dialog/annuity-cat-price-dialog.component';
import { CategoryPrice } from 'src/app/models/category-price';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-annuity-lot-dialog',
  templateUrl: './annuity-lot-dialog.component.html',
  styleUrls: ['./annuity-lot-dialog.component.scss']
})
export class AnnuityLotDialogComponent implements OnInit {

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  public matcher = new FormErrorStateMatcher();

  public lotForm: FormGroup;
  public displayedLotPricesColumns: string[] = ['icon', 'category', 'value', 'defaulting', 'edit', 'delete'];

  constructor(
    private dialog: MatDialog,
    public _annuityLotService: AnnuityLotService,
    public _annuityPriceService: AnnuityPriceService,
    public _annuityCatPriceService: AnnuityCatPriceService,
    private _adapter: DateAdapter<any>,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this._adapter.setLocale('pt');
    this._annuityLotService.currentProductLot = this.data.lot;
    this._annuityLotService.currentProduct = this.data.product;

    this._annuityLotService.setEdit()
    this.lotForm = this._annuityLotService.createForm(this._annuityLotService.currentProductLot);
  }

  ngAfterViewInit() {

    if (this._annuityLotService.currentProductLot.id) {
      this._annuityCatPriceService.loadCategoryPrices(this._annuityLotService.currentProduct.id, this._annuityLotService.currentProductLot.id)
    } else {
      this._annuityCatPriceService.productCatPricePartnerTrueDataSource = null;
      this._annuityCatPriceService.productCatPricePartnerFalseDataSource = null;
    }

  }

  insert() {
    if (this.lotForm.valid) {
      this._annuityLotService.insert(this.lotForm.value)
        .then((e) => {
          this.lotForm.controls.id.setValue(e)
        })
    }
  }

  update() {
    if (this.lotForm.valid) {
      this._annuityLotService.update(this.lotForm.value);

    }
  }

  deletePrice(element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.value + " <br><br>Excluir este preço?" }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        
        console.log("element.id  ====>>> : " + element.id)

        this._annuityCatPriceService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete price item error: " + error.message) }
          )

      }
    })

  }

  //remove
  openPriceDialog(element) {
    let data: Lot = new Lot();

    if (element) {
      data = element;
    }

    this.dialog.open(AnnuityPriceDialogComponent, {
      width: '800px',
      height: '550px',
      panelClass: 'custom-dialog-container',
      data: { price: data, lot: this._annuityLotService.currentProductLot }
    });
  }


  openCatPriceDialog(isPartner, entity) {

    // console.log("entity: " + JSON.stringify(entity))

    let data: CategoryPrice = new CategoryPrice();

    if (entity) {
      data = entity;
    }

    this.dialog.open(AnnuityCatPriceDialogComponent, {
      width: '800px',
      height: '520px',
      panelClass: 'custom-dialog-container',
      data: {
        'isPartner': isPartner,
        'categoryPrice': data,
        'lot': this._annuityLotService.currentProductLot,
        'product': this._annuityLotService.currentProduct
      }
    });
  }


}
